export default [
  {
    path: "/app/:userDeptRoleId/contact",
    components: {
      default: () => import("../views/contact/index.vue")
    },
    name: "contact"
  }
];



// WEBPACK FOOTER //
// ./src/router/contact.js